"use client"

import { useState } from "react"
import "./RetailFaq.css"

const faqData = [
  {
    question: "What are the key features of retail software?",
    answer:
      "Key features of retail software typically include inventory management, customer management, sales reporting and analytics, employee management, and multi-channel sales integration. Advanced solutions may also offer features like AI-driven recommendations, loyalty programs, and personalised marketing.",
  },
  {
    question: "What is proptech and examples?",
    answer:
      "PropTech stands for Property Technology and involves the application of technology to real estate markets to solve traditional challenges and create new opportunities. Examples include:• Online real estate marketplaces• Virtual reality (VR) tours for property viewing• Smart home technology for automated property management• Blockchain for secure and transparent transactions• AI-driven platforms for property valuation and investment analysis",
  },
  {
    question: "How does retail software improve custoemer experience?",
    answer:
      "Retail software improves customer experience by providing personalised shopping experiences, reducing checkout times, offering loyalty rewards, and ensuring consistent service across all channels. It also helps retailers keep the products customers want in stock, enhancing overall satisfaction.",
  },
  {
    question:
      "What are the challenges in retail software development?",
    answer:
      "Challenges in retail software development include integrating with existing systems, ensuring data security, managing inventory across multiple channels, and adapting to rapidly changing consumer behaviours. Developing a user-friendly interface that meets the needs of both employees and customers is also a significant challenge.",
  },
  {
    question: "How can businessess choose the right retail software company?",
    answer:
      "Businesses should look for a company with experience in the retail industry, a portfolio of successful projects, positive client testimonials, and the ability to provide comprehensive support and maintenance. Choosing a company that understands your specific business needs and can offer customised solutions is also essential.",
  },
  {
    question: "How does retail software integrate with other business systems?",
    answer:
      "Retail software can integrate with other business systems, such as ERP (Enterprise Resource Planning), CRM (Customer Relationship Management), and supply chain management systems through APIs (Application Programming Interfaces). This integration allows seamless data exchange and process automation across different business areas.",
  },
  {
    question:
      "What is the future of retail software development?",
    answer:
      "The future of retail software development will likely focus on further personalisation, enhanced customer engagement through technology (like AR and VR), and greater efficiency in operations through automation and AI. Sustainability and ethical business practices will also influence the development of retail software.",
  },
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section7328">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">RETAIL SOFTWARE DEVELOPMENT</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
